import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "303",
  "slug": "spot-philippines-from-satellite-imagery",
  "title": "How to Recognise the Philippines in Satellite Images",
  "excerpt": "The Philippines consists of islands with varied coastlines and mountainous interiors.",
  "date": "2026-04-07",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/philippines.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Philippines consists of islands with varied coastlines and mountainous interiors. Luzon lies in the north, the Visayas occupy the centre, and Mindanao is farther south. Volcanic cones can be visible in detailed views, but the broader island arrangement is more useful for regional orientation."
    },
    {
      "type": "heading",
      "text": "Luzon, the Visayas, and Mindanao"
    },
    {
      "type": "paragraph",
      "text": "Locate Luzon and Mindanao on the overview, then compare the more fragmented island pattern between them."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Indonesia also has tropical volcanic islands and terraced agriculture. A close crop of rice fields will not distinguish them reliably. Compare the visible coast with the outline of a candidate island and check for nearby islands."
    }
  ],
  "imageAlt": "the Philippines regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
